:host {
  --font-family: 'Montserrat', sans-serif;
  height: auto;
}

.wrapper {
  flex-direction: column;
  height: 100%;
}

.page__header {
  padding: calc(2 * var(--spacer)) calc(2 * var(--spacer)) calc(2 * var(--spacer)) calc(2.5 * var(--spacer));
}

.section-title {
  padding: calc(2 * var(--spacer)) calc(2 * var(--spacer)) calc(2 * var(--spacer)) calc(2.5 * var(--spacer));
}

.custom-template-list {
  max-height: calc(100% - 40px);
  max-width: 80%;
  margin-left: calc(2.5 * var(--spacer));
  margin-bottom: 80px;
}


.gz-card-custom {
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  margin: 0 8px 8px 0;
}


.content {
  flex-grow: 2;
  height: 100%;

  .grid {
    height: 100%;
  }

  .grid-view {
    min-height: 100%;
    align-items: stretch;

    gz-link {
      --cursorType: pointer;
    }
  }
}
